import { Dispatch, SetStateAction } from "react"
import { Node } from "reactflow"
import { VehicleService } from '../../../services/VehicleService'
import { VehicleResearchResponse } from "../../../types/vehicle"
import { ResearchTreeConfig } from '../researchTree/ResearchTree'

export const buildDonateNodes: (
	userId: number, 
	data: VehicleResearchResponse[], 
	setTriggerUpdate: Dispatch<SetStateAction<number>>,
	hoverCarNode?: Function
) => Node<any, string | undefined>[] | undefined = (
	userId: number, 
	data: VehicleResearchResponse[], 
	setTriggerUpdate: Dispatch<SetStateAction<number>>,
	hoverCarNode?: Function
) => {
	const nodes: Node<any, string | undefined>[] = []

	const map = (vehicle: VehicleResearchResponse) => {
				if (vehicle.donatePrice <= 0) return undefined
				return {
					id: vehicle.id.toString(),
						data: {
							name: vehicle.name,
							brand: vehicle.brand,
							rank: vehicle.rank,
							img: vehicle.modelName,
							checked: vehicle.bought,
							isDonated: true,
							button: {
								type: 'DONATE',
								price: vehicle.donatePrice,
								onClick: async () => VehicleService.buyVehicle(vehicle.id)
							},
							setTriggerUpdate: setTriggerUpdate,
							hoverCarNode: hoverCarNode
						},
					position: getPosition(
						vehicle.rank, 
						getSiblingIndex(vehicle, data, nodes)
					),
					type: 'car'
				}
			}
	
			data.forEach((vehicle: VehicleResearchResponse) => {
				const node = map(vehicle)
				if (node) nodes.push(node)
			})
	
	return nodes
}

const getPosition = (rank: number, siblingIndex: number) => {
	return {
		x: 0 + (rank - 1) * ResearchTreeConfig.HORIZONTAL_SPACE_BETWEEN_VEHICLES,
		y: siblingIndex * ResearchTreeConfig.VERTICAL_SPACE_BETWEEN_SIBLINGS
	}
}

const getSiblingIndex = (vehicle: VehicleResearchResponse, vehicles: VehicleResearchResponse[], nodes: Node<any, string | undefined>[]) => {

	const isSameRank = (vehicle1: VehicleResearchResponse, vehicle2: VehicleResearchResponse) => {
		return vehicle1.rank === vehicle2.rank
	}

	const isAtLeastOneAlreadyInList = (vehicle2: VehicleResearchResponse) => {
		return nodes.some((node: Node<any, string | undefined>) => node.id === vehicle2.id.toString())
	}

	const vehiclesSortedWithSiblings = vehicles.filter((otherVehicle: VehicleResearchResponse) => 
		isSameRank(vehicle, otherVehicle) 
	&& isAtLeastOneAlreadyInList(otherVehicle)
	)

	return vehiclesSortedWithSiblings.length
}